exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-select-dropdown.el-popper{width:calc(100% - 50px)}", "", {"version":3,"sources":["/Users/trungnq/Code/vital/sns/public/pwa/src/components/survey.vue"],"names":[],"mappings":"AACA,8BACE,uBAAyB,CAC1B","file":"survey.vue","sourcesContent":["\n.el-select-dropdown.el-popper {\n  width: calc(100% - 50px);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-472eda68","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/survey.vue
// module id = 810
// module chunks = 0